var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Select } from '../Select/index.js';
import { FormControlMeta } from './FormControlMeta.js';
import { Label } from './Label.js';
export const FormControlSelect = props => {
    const { name, label, helperText, error, invalid, onChange } = props, rest = __rest(props, ["name", "label", "helperText", "error", "invalid", "onChange"]);
    return (React.createElement("div", null,
        label ? React.createElement(Label, { htmlFor: name }, label) : null,
        React.createElement("div", { className: "mt-1" },
            React.createElement(Select, Object.assign({}, rest, { onChange: onChange, name: name, invalid: invalid })),
            React.createElement(FormControlMeta, Object.assign({}, { helperText, error, invalid })))));
};
//# sourceMappingURL=FormControlSelect.js.map